/**
 * Primary navigation, languages and footer columns.
 * Labels are English keys — pass them through t() at render time.
 */
export const NAV = [
  { id: 'home', label: 'Home', to: '/' },
  { id: 'about', label: 'About Ayodhya', to: '/about' },
  { id: 'temples', label: 'Temples & Darshan', to: '/temples' },
  {
    id: 'booking',
    label: 'Booking',
    children: [
      { label: 'Darshan Booking', to: '/darshan-booking', icon: 'temple', desc: 'Ram Mandir passes & timings' },
      { label: 'Hotel Booking', to: '/hotels', icon: 'bed-double', desc: 'Verified stays near the Mandir' },
      { label: 'Puja Booking', to: '/epuja', icon: 'diya', desc: 'E-puja with prasad delivery' },
      { label: 'Pandit Ji', to: '/pandits', icon: 'namaste', desc: 'Book experienced pandits' },
      { label: 'Aarti Passes', to: '/aarti', icon: 'aarti', desc: 'Mangla, Shringar & Shayan aarti' },
    ],
  },
  {
    id: 'guide',
    label: 'Travel Guide',
    children: [
      { label: 'Travel Guide', to: '/travel-guide', icon: 'compass', desc: 'How to reach, stay & explore' },
      { label: 'Trip Planner', to: '/travel-planner', icon: 'route', desc: 'Build a 1–5 day itinerary' },
      { label: 'Temple Timings', to: '/temple-timings', icon: 'clock', desc: 'Darshan & aarti schedule' },
      { label: 'Ghats', to: '/ghats', icon: 'waves', desc: 'Sacred banks of the Saryu' },
      { label: 'Festivals', to: '/festivals', icon: 'sparkles', desc: 'Ram Navami, Deepotsav & more' },
      { label: 'Pilgrim Services', to: '/services', icon: 'handshake', desc: 'Transport, food & essentials' },
    ],
  },
  { id: 'seva', label: 'Seva & Donation', to: '/seva' },
  { id: 'blog', label: 'Blog', to: '/blog' },
  { id: 'contact', label: 'Contact Us', to: '/contact' },
];

export const LANGUAGES = [
  { code: 'en', label: 'English' },
  { code: 'hi', label: 'हिंदी' },
  { code: 'gu', label: 'ગુજરાતી' },
  { code: 'mr', label: 'मराठी' },
];

export const FOOTER_COLUMNS = [
  {
    title: 'Explore',
    links: [
      ['About Ayodhya', '/about'],
      ['Temples & Darshan', '/temples'],
      ['Ghats', '/ghats'],
      ['Festivals', '/festivals'],
      ['Gallery', '/gallery'],
      ['Blog', '/blog'],
    ],
  },
  {
    title: 'Bookings',
    links: [
      ['Darshan Booking', '/darshan-booking'],
      ['Hotel Booking', '/hotels'],
      ['Puja Booking', '/epuja'],
      ['Pandit Ji', '/pandits'],
      ['Aarti Passes', '/aarti'],
    ],
  },
  {
    title: 'Plan',
    links: [
      ['Travel Guide', '/travel-guide'],
      ['Trip Planner', '/travel-planner'],
      ['Temple Timings', '/temple-timings'],
      ['Pilgrim Services', '/services'],
      ['Seva & Donation', '/seva'],
    ],
  },
  {
    title: 'Company',
    links: [
      ['Contact Us', '/contact'],
      ['Terms & Conditions', '/terms'],
      ['Privacy Policy', '/privacy'],
    ],
  },
];

export const CONTACT = {
  email: 'contact@ayodhyadham.info',
  phone: '+91 5555-123456',
  address: 'Ayodhya, Uttar Pradesh 224123, India',
};
